import formatStringByPattern from "format-string-by-pattern";

const phone = (value) => {
  const onlyNumbers = value.replace(/[^\d]/g, "");
  return formatStringByPattern("(999) 999-9999", onlyNumbers);
};

const formatter = (name, schemaProps, formApi) => {
  if (schemaProps && formApi) {
    // dynamic logic here
  }
  const formatters = {
    phone: phone,
  };
  return formatters[name];
};

export default formatter;
